import React, { useState, useEffect } from "react";
import { Row, Col, Card } from "antd";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

export default function ScriptCard(props) {
  const [question, setQuestion] = useState({});
  const [profileNames, setProfileNames] = useState(null);
  // const [selectedDate, setSelectedDate] = useState("");
  const [selectedAnswer, setSelectedAnswer] = useState("");

  useEffect(() => {
    const { questionInfo, profileNames, selectedDate } = props;
    if (questionInfo) {
      setQuestion(questionInfo);
      if (
        selectedDate !== undefined &&
        selectedDate !== null &&
        selectedDate !== ""
      ) {
        // setSelectedDate(selectedDate);
        setSelectedAnswer(questionInfo[selectedDate]?.answer);
      } else {
        setSelectedAnswer(questionInfo?.questionDetails?.answer);
      }
    }
    if (profileNames) {
      setProfileNames(profileNames);
    }
  }, [props]);

  return (
    <Card className="card-container"
      hoverable
      bodyStyle={{
        padding: "0px 18px",
        maxWidth:
          props?.cardWidth !== undefined ? `${props?.cardWidth}px` : "100%",
      }}
      key={question?.id}
    >
      <h3>
        {question?.questionDetails?.question
          .toString()
          .replace(
            "[NICKNAME]",
            profileNames?.nickName
              ? profileNames?.nickName
              : profileNames?.firstName
              ? profileNames?.firstName
              : profileNames?.dbNickName
          )}
      </h3>

      <div style={{ marginTop: "-15px" }}>
        <h4 style={{ color: "grey" }}>
          {question?.questionDetails?.explanation || ""}
        </h4>
        {selectedAnswer != null &&
        selectedAnswer !== undefined &&
        selectedAnswer !== "" ? (
          <div>
            {selectedAnswer?.textAns && (
              <div>
                <p style={{ color: "red" }}>
                  {question.questionDetails.answer.textAns}
                </p>
              </div>
            )}

            {selectedAnswer?.presetAns?.length > 0 && (
              <div className="scrollmenu">
                {selectedAnswer?.presetAns.map((item, index) => (
                  <div className="scrollItem">
                    <span
                      key={index}
                      style={{
                        borderColor:
                          item?.toLowerCase() === "yes" ||
                          item?.toLowerCase() === "no" ||
                          item?.toLowerCase() === "not applicable" ||
                          item?.toLowerCase() === "not applicable (none)"
                            ? "white"
                            : null,

                        color:
                          item?.toLowerCase() === "yes"
                            ? "green"
                            : item?.toLowerCase() === "no" ||
                              item?.toLowerCase() === "not applicable" ||
                              item?.toLowerCase() === "not applicable (none)"
                            ? "red"
                            : "black",
                        fontSize: "16px",
                      }}
                      className={
                        item?.toLowerCase() === "yes" ||
                        item?.toLowerCase() === "no" ||
                        item?.toLowerCase() === "not applicable" ||
                        item?.toLowerCase() === "not applicable (none)"
                          ? null
                          : "answerPresetItem"
                      }
                    >
                      {item?.toLowerCase() === "yes" ? (
                        <CheckCircleOutlined
                          style={{
                            color:
                              item?.toLowerCase() === "yes" ? "green" : "black",
                          }}
                        />
                      ) : item?.toLowerCase() === "no" ||
                        item?.toLowerCase() === "not applicable" ||
                        item?.toLowerCase() === "not applicable (none)" ? (
                        <ExclamationCircleOutlined
                          style={{
                            color:
                              item?.toLowerCase() !== "yes" ? "red" : "black",
                          }}
                        />
                      ) : (
                        ""
                      )}{" "}
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            )}

            {selectedAnswer?.defaultPrompts?.length > 0 && (
              <div className="scrollmenu">
                {selectedAnswer?.defaultPrompts.map(
                  (item, index) =>
                    item.checked && (
                      <div className="scrollItem">
                        <span key={index} className="answerPresetItem">
                          {item.prompt}
                        </span>
                      </div>
                    )
                )}
              </div>
            )}

            <Row gutter={[8, 8]}>
              {selectedAnswer?.additionalQuestions?.map(
                (item) =>
                  item?.answer && (
                    <Col span={24}>
                      <div>
                        <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                          {item?.question
                            .toString()
                            .replace(
                              "[NICKNAME]",
                              profileNames?.nickName
                                ? profileNames?.nickName
                                : profileNames?.firstName
                                ? profileNames?.firstName
                                : profileNames?.dbNickName
                            )}
                        </p>
                        <p style={{ fontSize: "12px", marginTop: "-10px" }}>
                          {item.answer}
                        </p>
                      </div>
                    </Col>
                  )
              )}
            </Row>
          </div>
        ) : (
          <h4 style={{ color: "#a5a5a5" }}>Not Answered</h4>
        )}
      </div>
    </Card>
  );
}
